import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/GeneralSettings';

import { getIsYangoRequest } from '../utils';

import { wrapInText } from './i18n-utils';

const t = i18n(keyset);

export const spamAgreenemt = (
    <>
        {wrapInText(
            (s) => <a href="https://yandex.ru/legal/confidential/">{s}</a>,
            (s) => <a href="https://yandex.ru/legal/dialogues_termsofuse/07032018/?lang=ru">{s}</a>,
        )(t(getIsYangoRequest() ? 'description-receive-global-yango' : 'description-receive-global-yandex'))}
    </>
);

export const getSpamAgreement = () => (
    <>
        {wrapInText(
            (s) => <a href="https://yandex.ru/legal/confidential/">{s}</a>,
            (s) => <a href="https://yandex.ru/legal/dialogues_termsofuse/07032018/?lang=ru">{s}</a>,
        )(t(getIsYangoRequest() ? 'description-receive-global-yango' : 'description-receive-global-yandex'))}
    </>
);
